import React from 'react'
import { Helmet } from 'react-helmet-async'
import BestCateringPage from '../components/BestCateringPage'
import Footer from '../components/Footer'
import './css/BestCatering.css'
import SocialEventsImg from './../assets/gallery/Social events.jpg';


function Home() {
  return (
    <div className='Home'>

      <Helmet>
        <title>Delicious Delights from Plaza Catering - Best Catering Services in Kochi!</title>
        <meta name='keywords' content=' best catering services in Kochi, best catering services in Kochi,catering services in Kochi,catering services in Kochi ' />
        <meta name='description' content='Discover the best catering services in Kochi with Plaza Catering. Indulge in exquisite culinary delights and impeccable service for your events and occasions. Contact us for a memorable dining experience!' />

        <link rel='canonical' href='/' />
      </Helmet>

      <BestCateringPage />

      <Footer />
    </div>
  )
}

export default Home